import React from "react";
import {
  ApolloProvider,
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  concat,
  HttpLink,
} from "@apollo/client";

interface Props {
  children: any;
}

const envMiddleware = new ApolloLink((operation: any, forward: any) => {
  // add the authorization to the headers
  operation.setContext(({ headers = {} }) => ({
    headers: {
      env: process.env.REACT_APP_BACKEND_API_ENVIRONMENT,
      ...headers,
    },
  }));

  return forward(operation);
});
const httpLink = new HttpLink({ uri: process.env.REACT_APP_GRAPHQL });
const client = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL,
  cache: new InMemoryCache(),
  link: concat(envMiddleware, httpLink),
});

const ApolloRootProvider: React.FC<Props> = ({ children }: Props) => (
  <ApolloProvider client={client}>{children}</ApolloProvider>
);

export default ApolloRootProvider;
